import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../../components/dynamicicon";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Constants from "../../constants";
import { ShareContext } from "../../context/ShareContext";
import BackLoader from "../../components/backloader";
import JisButton from "../../components/controls/jisButton";
import CaseSearch from "../../components/core/case_search";
import JisEmptyList from "../../components/controls/emptylist";
import Pagenated from "../../components/pagenated";
import CaseDetails from "../../components/core/caseDetails";
import JisDialog from "../../components/dialog";
import JisYesNo from "../../components/controls/jisYesNo";
import JisCheckbox from "../../components/controls/jisCheckbox";
import moment from "moment";
import JisTabButton from "../../components/controls/jisTabButton";
import NewGif from "../../assets/new_icon.gif";
import JisDialogForm from "../../components/formdialog";
import DeadlineBadge from "../../components/controls/deadlinebadge";
import CustomSearchSortHeader from "../../components/core/CustomSearchSortHeader";
import { BuildingIcon, VideoIcon } from "../../assets/svg";
import { XIcon } from "lucide-react";
import useComments from "../../hooks/useComment";

function JudgeCases() {
  const navigate = useNavigate();
  const { eventtype } = useParams();
  const { activePage, token, profile, frequentData, setIsExpired, setAlert,holidays } =
    useContext(ShareContext);
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.PAGESIZE);
  const [isSearch, setIsSearch] = useState(false);
  const [search, setSearch] = useState(null);
  const [err, setErr] = useState("");
  const [isPreview, setIsPreview] = useState(false);
  const [count, setCount] = useState(0);
  const [active, setActive] = useState(null);
  const [index, setIndex] = useState(-1);
  const [openCase, setOpenCase] = useState(false);
  const [isCmc, setIsCmc] = useState(null);
  const [openOption, setOpenOption] = useState(false);
  const [comment, setComment] = useState("");
  const [option, setOption] = useState({});
  const [suitNumber, setSuitnumber] = useState("");
  const [selected, setSelected] = useState(new Set()); //to hold the selected
  const [roles, setRoles] = useState([]);
  const [judges, setJudges] = useState([]);
  const [selectedCases, setSelectedCases] = useState({});
  const [assignTo, setAssignTo] = useState(null);
  const [roleCase, setRoleCase] = useState("all");
  const [caseState, setCaseState] = useState("unscheduled");
  const [schedule, setSchedule] = useState({});
  const [judge, setJudge] = useState(null);
  const [processCase, setProcessCase] = useState("all");
  const [openClear, setOpenClear] = useState(false);
  const [clearCommnent, setClearComment] = useState("");
  const [modal, setModal] = useState({
    type: null, // "case", "preview", "clear", "option"
    data: null,
  });
  const clearCommentRef = useRef(null);

  // Fetch predefined comments
  const { comments: predefinedComments, loading: commentsLoading } =
    useComments(token);

  const CommentDropdown = ({
    setNewValue,
    onChange,
    name,
    placeholder,
    required,
    reasonPlaceHolder,
  }) => {
    const [selectedComments, setSelectedComments] = useState([]);
    const [value, setValue] = useState("");
    // Load predefined selections from value
    useEffect(() => {
      if (value && predefinedComments.length > 0) {
        const parts = value
          .split(",")
          .map((v) => v.trim())
          .filter(Boolean);

        const predefinedSelected = parts.filter((p) =>
          predefinedComments.some((comment) =>
            typeof comment === "string" ? comment === p : comment.source === p,
          ),
        );

        setSelectedComments(predefinedSelected);
      }
    }, [value, setNewValue]);

    // Update parent component - works with both setValue and onChange patterns
    const updateParent = (finalValue) => {
      if (setValue) {
        setValue(finalValue);
      } else if (onChange) {
        onChange({ target: { name, value: finalValue } });
      }
    };

    // Merge and update the parent
    const updateFinal = (updatedSelected, customText) => {
      const cleanedCustom = customText.split(",").map((v) => v.trim());

      const finalValue = [...updatedSelected, ...cleanedCustom]
        .filter(Boolean)
        .join(", ");

      updateParent(finalValue);
    };

    // Handle checkbox change
    const handleCheckboxChange = (e) => {
      const { checked, value: comment } = e.target;

      const updatedSelected = checked
        ? [...selectedComments, comment]
        : selectedComments.filter((c) => c !== comment);

      setSelectedComments(updatedSelected);

      // Get current custom text (non-predefined parts)
      const currentParts = (value || "")
        .split(",")
        .map((v) => v.trim())
        .filter(Boolean);

      const customOnly = currentParts.filter(
        (p) =>
          !predefinedComments.some((comment) =>
            typeof comment === "string" ? comment === p : comment.source === p,
          ),
      );

      updateFinal(updatedSelected, customOnly.join(", "));
    };

    // Handle textarea typing
    const handleCustomChange = (e) => {
      const inputText = e.target.value;

      // Update parent immediately for responsive typing
      updateParent(inputText);

      // Update internal selected comments based on what's typed
      const parts = inputText
        .split(",")
        .map((v) => v.trim())
        .filter(Boolean);

      const predefinedInText = parts.filter((p) =>
        predefinedComments.some((comment) =>
          typeof comment === "string" ? comment === p : comment.source === p,
        ),
      );
      setSelectedComments(predefinedInText);
    };

    return (
      <div>
        {reasonPlaceHolder && (
          <p className="reason_placeholder">{reasonPlaceHolder}</p>
        )}
        <div className="predefined_comment_wrapper">
          {predefinedComments.map((comment, index) => {
            const commentText =
              typeof comment === "string" ? comment : comment.source;
            return (
              <label key={index} className="predefined_checkbox_wrapper">
                <input
                  type="checkbox"
                  value={commentText}
                  checked={selectedComments.includes(commentText)}
                  onChange={handleCheckboxChange}
                />
                <p>{commentText}</p>
              </label>
            );
          })}
        </div>

        <div>
          <label style={{ marginBottom: "120px" }} htmlFor="comments">
            comment
          </label>
          <textarea
            className="predefinedComments_textarea"
            ref={clearCommentRef}
            placeholder={placeholder}
            required={required}
            value={value}
            onChange={(e) => handleCustomChange(e)}
          />
        </div>
      </div>
    );
  };

  useEffect(() => {
    //  onLoad();
    onGetJudge();
  }, []);

  useEffect(() => {
    if (search != null) {
      if (pageIndex >= 0) {
        onSearch(search);
      } else {
        setPageIndex(0);
      }
    }
  }, [pageIndex, pageSize, search]);

  useEffect(() => {
    setPageIndex(-1); // this will trigger the loading
  }, [caseState, eventtype]);

  const onCaseStateChange = (s) => {
    setCases([]);
    setCaseState(s);
  };
  const onCheck = (value, opt) => {
    let sel = selected;
    let updateSel = { ...selectedCases };
    if (value) {
      sel.add(opt.caseId);
      updateSel[opt.caseId] = opt;
    } else {
      sel.delete(opt.caseId);
      delete updateSel[opt.caseId];
    }
    setSelected(new Set(sel));
    setSelectedCases(updateSel);
    console.log(Object.keys(updateSel));
  };
  const onSearch = async (sear) => {
    setSearch(sear);
    setLoading(true);
    try {
      // Use fixed payload for unscheduled trial cases, otherwise use search data
     /*  const payload =
        caseState === "unscheduled" && eventtype === "trial"
          ? { caseprocess: "all", filingtype: "litigation" }
          : sear; */

const payload =sear;
      const resp = await fetch(
        `${Constants.apiUrl}/filing/judge-cases/${eventtype}/${pageIndex}/${pageSize}/${caseState}`,
        {
          method: "POST",
          body: JSON.stringify(payload),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setCases(data.items);
        if (pageIndex == 0) {
          setCount(data.totalCount);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onLoad = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/judge-cases/${eventtype}/${pageIndex}/${pageSize}/${caseState}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //ready
        // fee, feelines, cinfo , parties
        setCases(data.items);
        if (pageIndex == 0) {
          setCount(data.totalCount);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onLoadRoles = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/profile/getrolesBySearch/judge`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //ready
        // fee, feelines, cinfo , parties
        setRoles(data.roles);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onLoadUserByRoleandDivision = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/profile/getUsersByRole/${option.roleId}/${option.divisionId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //ready
        // fee, feelines, cinfo , parties
        setJudges(data.pros);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    if (
      !(option.divisionId == null || option.divisionId == "") &&
      !(option.roleId == null || option.roleId == "")
    ) {
      setAssignTo(null);
      setJudges([]);
      onLoadUserByRoleandDivision();
    }
  }, [option.divisionId, option.roleId]);
  const onGetJudge = async () => {
    //for account registration

    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/profile/getjudgedetails-profile`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      var judge = data.judge;
      if (judge != null) {
        setJudge({
          ...judge,
          courtName: data.courtname,
          judgeType: data.judgetype,
          lastRank: data.lastRank,
        });
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onPagePick = (pick) => {
    console.log("this is selection value");
    setPageIndex(pick.id - 1);
    console.log(pick);
  };

  const onContinue = (fee, ind) => {
    navigate(`/case-details/${fee.caseId}`);
    // setActive(fee);
    // setIndex(ind);
    // setOpenCase(true);
  };

  const onPreview = (fee, ind) => {
    //navigate(`/case-details/${caseid}`)
    setActive(fee);
    setIndex(ind);
    setModal({ type: "preview", data: fee });
    // setIsPreview(true);
  };

  const onCloseOpenCase = () => {
    setActive(null);
    setIndex(-1);
    setModal({ type: null, data: null });
    // setOpenCase(false);
  };
  const onCloseClear = () => {
    setActive(null);
    setIndex(-1);
    setModal({ type: null, data: null });
    // setOpenClear(false);
  };

  const onSave = async (e) => {
    e.preventDefault();

    setErr("");
    const filterCase = cases.filter((k) => k.caseId === active.caseId);

    // var eventtype=isCmc==true?'CMC':'Trial';
    var obj = {
      ...schedule,
      eventType: eventtype ?? "ADR",
      CaseId: active.caseId,
      CourtId: judge.courtId,
      CourtRoomId: 0,
      JudgeId: profile.id,
    };

    setLoading(true);
    try {
      const resp = await fetch(`${Constants.apiUrl}/filing/shedule-case`, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setModal({ type: null, data: null });
        // setOpenOption(false);

        setAlert({
          open: true,
          title: "Case Schedule",
          subtitle: " Case scheduled successfully",
        });
        setPageIndex(-1); // this will auto load again
        setModal({ type: null, data: null });
        // setIsPreview(false);
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onOptionChange = (e) => {
    setOption({ ...option, [e.target.name]: e.target.value });
  };

  const onScheduleChange = (e) => {
    setSchedule({ ...schedule, [e.target.name]: e.target.value });
  };

  const onDirectSearch = (sear) => {
    setSearch(sear);
    setIsSearch(true);
    setPageIndex(0);
  };

  const onClear = (item, index) => {
    //load a dialog with
    setActive(item);
    setModal({ type: "clear", data: item });
    // setOpenClear(true);
  };

  const onSaveClear = async (e) => {
    e.preventDefault();
    const comment = clearCommentRef.current?.value;

    setLoading(true);
    try {
      var approve = { caseid: active.caseId, comment: comment };
      const resp = await fetch(
        `${Constants.apiUrl}/filing/adr-clear-case/judge/${active.caseId}`,
        {
          method: "POST",
          body: JSON.stringify(approve),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setModal({ type: null, data: null });
        // setOpenClear(false);

        setAlert({
          open: true,
          title: "Case Acceptance",
          subtitle: " Case(s) cleared  successfully",
        });
        setPageIndex(-1); // this will auto load again
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

  return (
    <div>
      {/* <CaseSearch
        onSearch={onDirectSearch}
        frequentData={frequentData}
        filingtype="litigation"
      /> */}
      <CustomSearchSortHeader
        onSearch={onDirectSearch}
        frequentData={frequentData}
        filingType="litigation"
      />

      <div className="tab_body">
        <div className="tab_section custom-tab-container">
          <JisTabButton
            code="unscheduled"
            isActive={caseState == "unscheduled"}
            title="Unscheduled Cases"
            isRoleBased={false}
            onClick={() => onCaseStateChange("unscheduled")}
          />
          <JisTabButton
            code="scheduled"
            isActive={caseState == "scheduled"}
            title="Scheduled Cases"
            data={null}
            isRoleBased={false}
            onClick={() => onCaseStateChange("scheduled")}
          />
          <JisTabButton
            code="concluded"
            isActive={caseState == "concluded"}
            title="Concluded "
            data={null}
            isRoleBased={false}
            onClick={() => onCaseStateChange("concluded")}
          />
        </div>
        {caseState == "unscheduled" && (
          <div className="tab_view">
            {cases?.length == 0 && <JisEmptyList />}
            {cases?.length > 0 && (
              <div className="table">
                <div class="section-cases">
                  <span>Unschedule Cases</span>
                  {/* <span className="total">{count}</span> */}
                </div>
                <div className="table-wrapper">
                  <table class="case-table">
                    <thead>
                      <tr>
                        <th className="col-title">Suit Number</th>
                        <th className="col-title">Case Title</th>
                        <th className="col-medium">Filing Type</th>
                        <th className="col-medium">Classification</th>
                        <th className="col-medium">Case Age(Days)</th>
                        <th className="col-medium">Date Initiated</th>
                        <th className="col-medium">Status Level</th>
                        {/* <th>SLA</th> */}
                        <th className="col-title">Details</th>
                        <th className="col-action">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cases?.map((opt, index) => {
                        const cc = Constants.getSlaTimeLeft(opt.slaExpire,holidays);
                        return (
                          <tr key={index}>
                            <td
                              style={{
                                backgroundColor: `${
                                  Constants.getItemById(
                                    frequentData?.casecategories,
                                    opt.caseCategoryId,
                                  )?.colour
                                }`,
                              }}
                            >
                              {opt.caseNumber || "N/A"}
                            </td>
                            <td>{opt.caseTitle || "N/A"}</td>
                            <td>
                              {Constants.getItemById(
                                frequentData?.casetype,
                                opt.caseTypeId,
                              )?.caseType1 || "N/A"}
                            </td>
                            <td>
                              {" "}
                              {Constants.getItemById(
                                frequentData?.casecategories,
                                opt.caseCategoryId,
                              )?.categoryTitle || "N/A"}
                            </td>
                            <td>
                              {moment().diff(opt.createdOn, "days") || "N/A"}
                            </td>
                            <td>
                              {" "}
                              {Constants.momentDate(opt.createdOn).format(
                                "DD MMM, YYYY",
                              ) || "N/A"}
                            </td>
                            <td>
                              {Constants.getItemById(
                                frequentData?.casestatuses,
                                opt.caseStatusId,
                              )?.description || "N/A"}
                            </td>
                            {/* <td>
                              {" "}
                              <DeadlineBadge
                                dateString={opt.case?.slaExpire}
                              />{" "}
                            </td> */}
                            <td>
                              <JisButton
                                variant="plain"
                                onClick={() => onContinue(opt, index)}
                              >
                                View
                              </JisButton>
                            </td>
                            <td>
                              {opt.caseFilingId == 1 && (
                                <JisButton
                                  variant="plain"
                                  onClick={() => onPreview(opt, index)}
                                >
                                  {/* {opt.isScheduled == null && (
                                    <img
                                      src={NewGif}
                                      style={{ width: 20, height: 20 }}
                                    />
                                  )} */}
                                  Schedule
                                </JisButton>
                              )}

                              {opt.caseFilingId == 2 && (
                                <JisButton
                                  variant="plain"
                                  onClick={() => onClear(opt, index)}
                                >
                                  {/* {opt.isScheduled == null && (
                                    <img
                                      src={NewGif}
                                      style={{ width: 20, height: 20 }}
                                    />
                                  )} */}
                                  Clear
                                </JisButton>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                {cases?.length > 0 && (
                  <Pagenated
                    onChangePageSize={(k) => setPageSize(k)}
                    size={pageSize}
                    total={count}
                    maxPage={20}
                    onPick={onPagePick}
                  />
                )}
              </div>
            )}
          </div>
        )}
        {caseState == "scheduled" && (
          <div className="tab_view">
            {cases?.length == 0 && <JisEmptyList />}
            {cases?.length > 0 && (
              <div className="table">
                <div class="section-cases">
                  <span>Scheduled Cases</span>
                  {/* <span className="total">{count}</span> */}
                </div>
                <div className="table-wrapper">
                  <table class="case-table">
                    <thead>
                      <tr>
                        <th className="col-title">Suit Number</th>
                        <th className="col-title">Case Title</th>
                        <th className="col-medium">Filing Type</th>
                        <th className="col-medium">Classification</th>
                        <th className="col-medium">Case Age(Days)</th>
                        <th className="col-medium">Schedule Date</th>
                        <th>Start Time</th>
                        <th>End Time</th>
                        <th>Status</th>
                        {/* <th>SLA</th> */}
                        <th className="col-title">Details</th>
                        <th className="col-medium">Schedule</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cases?.map((opt, index) => {
                        const cc = Constants.getSlaTimeLeft(opt.slaExpire,holidays);
                        // active schedule first; otherwise the last one (closed/adjourned) so the row still shows a date
                        const activeSch = opt.schedule?.[0];
                        const sch = activeSch || opt.lastSchedule;
                        return (
                          <tr key={index}>
                            <td
                              style={{
                                backgroundColor: `${
                                  Constants.getItemById(
                                    frequentData?.casecategories,
                                    opt.caseCategoryId,
                                  )?.colour
                                }`,
                              }}
                            >
                              {opt.caseNumber || "N/A"}
                            </td>
                            <td>{opt.caseTitle || "N/A"}</td>
                            <td>
                              {Constants.getItemById(
                                frequentData?.casetype,
                                opt.caseTypeId,
                              )?.caseType1 || "N/A"}
                            </td>
                            <td>
                              {" "}
                              {Constants.getItemById(
                                frequentData?.casecategories,
                                opt.caseCategoryId,
                              )?.categoryTitle || "N/A"}
                            </td>
                            <td>
                              {moment().diff(opt.createdOn, "days") || "N/A"}
                            </td>
                            <td>
                              {sch ? (
                                <>
                                  {Constants.momentDate(sch.scheduleDate)?.format("DD MMM, YYYY") || "N/A"}
                                  {!activeSch && (
                                    <div style={{ fontSize: 11, opacity: 0.75 }}>
                                      Last date{sch.scheduleStatus ? ` (${sch.scheduleStatus})` : ""} - reschedule
                                    </div>
                                  )}
                                </>
                              ) : (
                                "Not scheduled"
                              )}
                            </td>
                            <td>
                              {(sch && Constants.momentTime(sch.startTime)?.format("hh:mm A")) || "N/A"}
                            </td>
                            <td>
                              {(sch?.endTime && Constants.momentTime(sch.endTime)?.format("hh:mm A")) || "N/A"}
                            </td>
                            <td>
                              {Constants.getItemById(
                                frequentData?.casestatuses,
                                opt.caseStatusId,
                              )?.description || "N/A"}
                            </td>
                            {/* <td>
                              {" "}
                              <DeadlineBadge dateString={opt.slaExpire} />{" "}
                            </td> */}
                            <td>
                              <JisButton
                                variant="plain"
                                onClick={() => onContinue(opt, index)}
                              >
                                View
                              </JisButton>
                            </td>
                            <td>
                              <JisButton
                                variant="plain"
                                onClick={() => onPreview(opt, index)}
                              >
                                Reshedule
                              </JisButton>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                {cases?.length > 0 && (
                  <Pagenated
                    onChangePageSize={(k) => setPageSize(k)}
                    size={pageSize}
                    total={count}
                    maxPage={20}
                    onPick={onPagePick}
                  />
                )}
              </div>
            )}
          </div>
        )}
        {caseState == "concluded" && (
          <div className="tab_view">
            {cases?.length == 0 && <JisEmptyList />}
            {cases?.length > 0 && (
              <div className="table">
                <div class="section-cases">
                  <span>Concluded Cases</span>
                  {/* <span className="total">{count}</span> */}
                </div>
                <div className="table-wrapper">
                  <table class="case-table">
                    <thead>
                      <tr>
                        <th className="col-title">Suit Number</th>
                        <th className="col-title">Case Title</th>
                        <th className="col-medium">Filing Type</th>
                        <th className="col-medium">Classification</th>
                        <th className="col-medium">Case Age(Days)</th>
                        <th className="col-medium">Date Initiated</th>
                        <th className="col-medium">Status Level</th>
                        <th className="col-title">Details</th>
                        {/* <th className="col-medium">Schedule</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {cases?.map((opt, index) => {
                        const cc = Constants.getSlaTimeLeft(opt.slaExpire,holidays);
                        return (
                          <tr key={index}>
                            <td
                              style={{
                                backgroundColor: `${
                                  Constants.getItemById(
                                    frequentData?.casecategories,
                                    opt.caseCategoryId,
                                  )?.colour
                                }`,
                              }}
                            >
                              {opt.caseNumber || "N/A"}
                            </td>
                            <td>{opt.caseTitle}</td>
                            <td>
                              {Constants.getItemById(
                                frequentData?.casetype,
                                opt.caseTypeId,
                              )?.caseType1 || "N/A"}
                            </td>
                            <td>
                              {" "}
                              {Constants.getItemById(
                                frequentData?.casecategories,
                                opt.caseCategoryId,
                              )?.categoryTitle || "N/A"}
                            </td>
                            <td>
                              {moment().diff(opt.createdOn, "days") || "N/A"}
                            </td>
                            <td>
                              {" "}
                              {Constants.momentDate(opt.createdOn).format(
                                "DD MMM, YYYY",
                              ) || "N/A"}
                            </td>
                            <td>
                              {Constants.getItemById(
                                frequentData?.casestatuses,
                                opt.caseStatusId,
                              )?.description || "N/A"}
                            </td>
                            <td>
                              <JisButton
                                variant="plain"
                                onClick={() => onContinue(opt, index)}
                              >
                                View
                              </JisButton>
                            </td>
                            {/*   <td><JisButton onClick={()=>onPreview(opt,index)}>Schedule</JisButton></td> */}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                {cases?.length > 0 && (
                  <Pagenated
                    onChangePageSize={(k) => setPageSize(k)}
                    size={pageSize}
                    total={count}
                    maxPage={20}
                    onPick={onPagePick}
                  />
                )}
              </div>
            )}
          </div>
        )}
      </div>

      <BackLoader open={loading} />

      {modal.type === "clear" && (
        <JisDialogForm title="Case acceptance" onClose={onCloseOpenCase}>
          <form onSubmit={onSaveClear}>
            <h3>
              {active?.caseNumber}: {active?.caseTitle}
            </h3>
            <p>The case move back to ADR Admin with your minute(comment)</p>
            <div className="input-group">
              <CommentDropdown
                placeholder="comment"
                required={true}
                reasonPlaceHolder={"Reason (select all that apply)"}
                onChange={(e) => setClearComment(e.target.value)}
                name="clearComment"
              />
            </div>
            <div className="re-route_btn_wrapper">
              <button onClick={onCloseClear}>Cancel</button>
              <button type="submit">Save </button>
            </div>
          </form>
        </JisDialogForm>
      )}
      {modal.type === "case" && (
        <JisDialogForm title="Case Details" onClose={onCloseOpenCase}>
          <div>
            <CaseDetails
              caseId={active.caseId}
              data={null}
              token={token}
              initialtab="casedocuments"
            />
          </div>
        </JisDialogForm>
      )}

      {modal.type === "option" && (
        <JisDialogForm title=" Case Assignment">
          <form onSubmit={onSave}>
            <div style={{ display: "flex" }}>
              <div style={{ flex: 3 }}>
                {active.caseFilingId == 1 && (
                  <JisYesNo
                    label="Assign Case As... "
                    value={isCmc}
                    yes="CMC"
                    no="Trial"
                    onChange={(e) => setIsCmc(e)}
                  />
                )}
                <div>
                  <div className="select-group">
                    <label>Division</label>
                    <select
                      name="divisionId"
                      value={option.divisionId}
                      onChange={onOptionChange}
                      required
                    >
                      <option value="">Select </option>
                      {frequentData.divisions?.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="select-group">
                    <label>Role:</label>
                    <select
                      name="roleId"
                      value={option.roleId}
                      onChange={onOptionChange}
                      required
                    >
                      <option value="">Select Role </option>
                      {roles?.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="select-group">
                    <label>Judges:</label>
                    <div className="content-box" style={{ maxHeight: 300 }}>
                      {judges?.map((opt) => (
                        <div
                          key={opt.id}
                          onClick={() => setAssignTo(opt.id)}
                          className={`selected ${
                            opt.id == assignTo ? "active" : ""
                          }`}
                        >
                          {Constants.judgeName(opt)}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="input-group">
                  <CommentDropdown
                    placeholder=" Comment"
                    required={true}
                    reasonPlaceHolder={"Reason (select all that apply)"}
                    onChange={onOptionChange}
                    name="comment"
                  />
                </div>
                {err != "" && <div className="error">{err}</div>}
                <JisButton type="submit">Save </JisButton>{" "}
                <JisButton type="button" onClick={onCloseOpenCase}>
                  Cancel{" "}
                </JisButton>
              </div>
              <div style={{ flex: 1, maxHeight: 300 }} className="content-box">
                <div>
                  Selected Cases to Assign (
                  {Object.values(selectedCases).length})
                </div>
                {Object.values(selectedCases)?.map((opt, index) => (
                  <div className="selected" key={index}>
                    <div>{opt.caseNumber}</div>
                    <p style={{ fontSize: 12 }}>{opt.caseTitle}</p>
                  </div>
                ))}
              </div>
            </div>
          </form>
        </JisDialogForm>
      )}
      {modal.type === "preview" && (
        <div className={"schedule_case_form_wrapper"}>
          <div className="schedule_case_form">
            <div className="form-container">
              <div div className="form-header">
                <p className="form_title">Schedule New Case</p>
                <button className="close_btn" onClick={onCloseClear}>
                  <XIcon />
                </button>
              </div>
              <div className="form-panel">
                <div className="panel-body">
                  <form onSubmit={onSave}>
                    <div>
                      <div className="input-group">
                        <label> Case Type</label>
                        <div className="input-wrapper">
                          <input required={true} value={eventtype} disabled />
                        </div>
                      </div>

                      <div style={{ display: "flex" }}>
                        <div className="input-group">
                          <label> Case Number</label>
                          <div className="input-wrapper">
                            <input value={active.caseNumber} disabled />
                          </div>
                        </div>
                        <div className="input-group">
                          <label>Case Title</label>
                          <div className="input-wrapper">
                            <input value={active.caseTitle} disabled />
                          </div>
                        </div>
                      </div>

                      <div style={{ display: "flex" }}>
                        <div className="input-group">
                          <label>Date</label>
                          <div className="input-wrapper">
                            <input
                              name="scheduleDate"
                              type="date"
                              required
                              value={schedule.scheduleDate}
                              onChange={onScheduleChange}
                              placeholder="Date"
                            />
                          </div>
                        </div>
                        <div className="input-group">
                          <label> Start Time</label>
                          <div className="input-wrapper">
                            <DynamicIcon iname="acute" />
                            <input
                              placeholder="Start Time"
                              type="time"
                              name="startTime"
                              required={true}
                              value={schedule.startTime}
                              onChange={onScheduleChange}
                            />
                          </div>
                        </div>
                        <div className="input-group">
                          <label> End Time</label>
                          <div className="input-wrapper">
                            <DynamicIcon iname="chronic" />
                            <input
                              placeholder="Time"
                              type="time"
                              required={true}
                              name="endTime"
                              value={schedule.endTime}
                              onChange={onScheduleChange}
                            />
                          </div>
                        </div>
                      </div>

                      {/* <div className="case-location-wrapper">
                      <label
                        className="case_location_label"
                        htmlFor="physicalCourtroom"
                      >
                        <BuildingIcon />
                        <div>
                          <p className="title">Physical Courtroom</p>
                          <p className="description">In-person Hearing</p>
                        </div>
                        <input
                          type="radio"
                          name="location"
                          id="physicalCourtroom"
                        />
                      </label>
                      <label
                        className="case_location_label"
                        htmlFor="virtualCourtroom"
                      >
                        <VideoIcon />
                        <div>
                          <p className="title">Virtual Hearing</p>
                          <p className="description">Virtual Hearing</p>
                        </div>
                        <input type="radio" name="location" />
                      </label>
                    </div> */}
                      <div style={{ display: "flex" }}>
                        <div className="input-group">
                          <label>Court Room</label>
                          <div className="input-wrapper">
                            <DynamicIcon iname="chair_alt" />
                            <input
                              disabled
                              required={true}
                              value={judge?.lastRank ?? "000"}
                            />
                          </div>
                        </div>
                        <div className="input-group">
                          <label> Judge </label>
                          <div className="input-wrapper">
                            <DynamicIcon iname="email" />
                            <input
                              name="primaryEmail"
                              value={judge?.courtName}
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                      <div className="input-group">
                        <label> comment</label>
                        <div className="input-wrapper">
                          {" "}
                          <textarea
                            placeholder="Add Comment"
                            name="agenda"
                            required={true}
                            value={schedule.agenda}
                            onChange={onScheduleChange}
                          />
                        </div>
                      </div>

                      <div className="schedule_btn_wrapper">
                        <button type="button" onClick={onCloseClear}>
                          Cancel
                        </button>
                        <button type="submit">Save Schedule</button>{" "}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default JudgeCases;
